import { graphqlApolloClient } from "../graphql-apollo-client"
import { CREATE_ASSISTANCE } from "./graphql/create-assistance"

/**
 * @param {NewActivityAssistance[]} data
 * @return {Promise<*>}
 */
export const createAssistance = async ({ data }) => {
  const result = await graphqlApolloClient.mutate({
    mutation: CREATE_ASSISTANCE,
    variables: {
      data
    }
  })

  return result.data.CreateAssistance
}

/**
 * @typedef NewActivityAssistance
 * @property {string} activity
 * @property {string} projectAssistant
 * @property {string} assistanceAt
 */
